const GREEK_TONOS_MAP = {
  ά: "α",
  έ: "ε",
  ή: "η",
  ί: "ι",
  ό: "ο",
  ύ: "υ",
  ώ: "ω",
  Ά: "Α",
  Έ: "Ε",
  Ή: "Η",
  Ί: "Ι",
  Ό: "Ο",
  Ύ: "Υ",
  Ώ: "Ω",
  ΐ: "ϊ",
  ΰ: "ϋ"
};

export function stripGreekTonos(value) {
  return String(value || "").replace(
    /[άέήίόύώΆΈΉΊΌΎΏΐΰ]/g,
    (character) => GREEK_TONOS_MAP[character] || character
  );
}

export function toTitleCase(value) {
  return String(value || "")
    .toLocaleLowerCase("el-GR")
    .replace(
      /(^|[\s/-])([a-zα-ωάέήίόύώϊϋΐΰ])/giu,
      (match, prefix, character) => `${prefix}${character.toLocaleUpperCase("el-GR")}`
    );
}
